export class Constant {
  static TAU = 2 * Math.PI;
  static SIN_60 = 0.866;
  static PHI = 1.6180339887498948;
}
